import { Capacitor } from "@capacitor/core";
import { Utils } from "helpers/utils";
import type { AppUpdateCheckResult } from "helpers/utils";
import { APIClient } from "./apiCore";
import * as url from "./urls";
import { FrontEndApp } from "const";

const api = new APIClient();

const getProfileDetails = () => {
  return api.get(url.GET_PROFILE_DETAILS);
};

const getSettings = () => {
  return api.get(url.GET_USER_SETTINGS);
};

const loadThirdApiUrl = () => {
  return api.fnGet("/load-third-api-url");
}

const checkAppUpdateChatNative = (versionCode: string, browser: string, device: string, os: string, platform: string, deviceId: string, userType: string | null) => {
  return api.fnPostForm(url.CHECK_APP_UPDATE_CHATNATIVE, { versionCode, browser, device, os, platform, deviceId, userType });
}

// The backend's C# model is PascalCase (ForceUpdate, IsUpTodate, ...) and ASP.NET Core's
// default JSON serialization camelCases that (forceUpdate, isUpTodate, ...) - neither matches
// AppUpdateCheckResult's all-lowercase fields (forceupdate, isuptodate, ...), so every value
// would silently come back undefined. Normalize keys to lowercase here so this works regardless
// of which casing convention the backend actually serializes with.
const normalizeKeysToLowercase = (obj: any): any => {
  if (!obj || typeof obj !== "object") return obj;
  const result: any = {};
  for (const key of Object.keys(obj)) {
    result[key.toLowerCase()] = obj[key];
  }
  return result;
};

// Shared by the boot-time saga (redux/settings/saga.ts) and the manual "check for update"
// button (Settings page) so both build the request and persist the result the same way.
// userType is the raw Profile2.userType enum value (or null/undefined if not authenticated).
const performAppUpdateCheck = async (userType?: number | null): Promise<AppUpdateCheckResult> => {
  const deviceInfo = Utils.GetAppUpdateCheckDeviceInfo();
  const versionCode = await Utils.GetDisplayAppVersion();
  const rawResponse = await checkAppUpdateChatNative(
    versionCode,
    deviceInfo.browser,
    deviceInfo.device,
    deviceInfo.os,
    deviceInfo.platform,
    Utils.GetDeviceId(),
    Utils.GetUserTypeCodeForUpdateCheck(userType)
  );
  const response: AppUpdateCheckResult = normalizeKeysToLowercase(rawResponse);
  Utils.SetAppUpdateInfo(response);
  return response;
}

const updateSettings = (field: string, value: any) => {
  return api.update(url.UPDATE_ETTINGS, {
    field: field,
    value: value,
  });
};

const updateFcmTokenAsync = async (token: string) => {
  // try {
    let body = JSON.stringify({
      EndPoint: token,
      P256DH: '',
      Auth: '',
      DeviceId: localStorage.getItem("did4") ?? "",
      AppName: process.env.REACT_APP_NAME,
      AppAbbr: process.env.REACT_APP_COMPANY_ABBR,
      frontEndApp: Capacitor.isNativePlatform() ? FrontEndApp.AppChat2SNative : FrontEndApp.AppChat2S
    });
    //  console.log('updateFcmTokenAsync:', body);
    const response = await fetch(`${process.env.REACT_APP_APIURL}/push/subscribe`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${Utils.JwtTokenGet()}` // 20250708
      },
      body: body,
      credentials:'include'
    });
    // console.log('updateFcmTokenAsync:', response);
    return response;
  // } catch (e) {
  //   console.error('updateFcmTokenAsync:', e);
  //   return null;
  // }
}

export { getProfileDetails, getSettings, updateSettings, updateFcmTokenAsync, loadThirdApiUrl, checkAppUpdateChatNative, performAppUpdateCheck };
